<template>
    <div>
        <div class="px-2">
            <div class="my-2">
                <h2>{{$t('export_localizations_data_csv_format')}}</h2>
                <br>
            </div>
            <div class="my-2">
                {{$t('enable_following_tracker')}} ({{ selected_devices.length }}/{{devices_ids.length}})<br>
                <div v-if="devices_ids">
                  <multiselect
                      v-model="selected_devices"
                      :options="devices_options"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :hide-selected="true"
                      :preserve-search="true"
                      :select-label="$t('select')"
                      :selected-label="$t('selected')"
                      :deselect-label="$t('deselect_label')"
                      :placeholder="$t('select_devices_export')"
                      :custom-label="device_label"
                      @select="select_device"
                  >
                  </multiselect>
                </div>
              <div class="py-2 my-2">
                <button  v-if="selected_devices.length" @click="deselectAll" class="btn btn-sm btn-secondary">
                  {{$t('deselect_all_devices')}}
                </button>
            </div>
                <div class="my-2">
                  Format: <select v-model="format">
                  <option value="csv">CSV</option>
                  <option value="gpx">GPX</option>
                </select>
                </div>
                <div class="form-group align-middle dropup my-2" v-show="title_range">
                    <div id="daterange" class="btn align-middle dropdown-toggle">
                        <span data-feather="calendar"></span>
                        <span>{{title_range}}</span>
                    </div>
                </div>
                <div class="row mx-2 mb-2">
                    <button v-if='selected_devices.length' class="btn btn-success" @click="on_export">
                        {{$t('submit')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HTTP} from '../http-constants'
    import Multiselect from 'vue-multiselect'
    import $ from 'jquery'
    let moment = require('moment')

    export default {
        components: {
            multiselect: Multiselect,
        },
        data() {
            return {
                devices: [],
                devices_ids: [],
                devices_options: [],
                selected_devices: [],
                date_start: '',
                date_end: '',
                title_range: null,
                format: 'csv'
            }
        },
        methods: {
          load_devices: function () {
            var self = this;
            HTTP.get('/devices/?type=tracker',)
                .then(function (re) {
                  self.devices = re.data;
                  self.devices_ids = self.devices.map(a => a.id);
                  self.devices_options = self.devices_ids.slice();
                  self.devices_options.unshift(-1);
                  self.selected_devices = [...self.devices_ids];
                })
                .catch(function (error) {
                  console.log(error);
                });
          },
          select_device: function (option) {
            console.log("Selected option:", option);
            if (option === -1) {
              this.selected_devices = this.devices_ids;
            } else {
              this.selected_devices.push(option);
            }
          },
          deselectAll: function () {
            this.selected_devices = [];
          },
          'device_label': function (option) {
            if (option < 0) {
              return app.$t('select_all');
            }
            let devices = this.devices.filter(a => a.id === option);
            if (devices.length) {
              return devices[0].name;
            }
            return `${option}`
          },
          'date_range_title': function () {
            if (this.date_start == '') {
              return "...";
            }

            const _diff = this.date_end.diff(this.date_start, 'hours');
            let _title = this.date_start.format('dddd Do MMMM');
            if (_diff > 24) {
              _title += " - " + this.date_end.format('dddd Do MMMM');
            }
            return _title
          },
          'on_export': function () {
            let self = this;
            const date_start = this.date_start.format('YYYY-MM-DD');

            let days = this.date_end.diff(this.date_start, 'days');
            const selected_devices_ids = this.selected_devices;

            let filename = 'export_' + date_start;
            if (days > 1) {
              let date_end = this.date_end.format('YYYY-MM-DD');
              filename = 'export_' + date_start + "_" + date_end;
            }
            if (self.format == 'gpx') {
              filename += ".gpx"
            } else {
              filename += ".csv"
            }

            HTTP({
              url: '/tracker_data_export/',
              method: 'POST',
              responseType: 'blob',
              data: {
                'date': date_start,
                'days': days,
                'devices': selected_devices_ids,
                'format': self.format
              }
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename); //or any other extension
              document.body.appendChild(link);
              link.click();
            });
          }
        },
        mounted: function () {

            this.date_start = moment().startOf('day');
            this.date_end = moment().startOf('day').add(1, 'days');
            this.title_range = this.date_range_title();

            var startDay = this.date_start;
            var self = this;
            $('#daterange').daterangepicker({
                "locale": {
                    "format": 'dddd Do MMMM',
                    "separator": " - ",
                    "applyLabel": "Valider",
                    "cancelLabel": "Annuler"
                },
                startDate: startDay,
                todayHighlight: true,
                opens: 'center',
            }, function (start, end) {
                console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
                self.date_start = start;
                self.date_end = end;
                self.title_range = self.date_range_title();
            });

            this.load_devices();
        }
    }
</script>
